import Column from "@components/column";
import SectionTitleForm from "./form";
import SectionTitleList from "./list";

const ManageSectionTitle = () => {
  return (
    <Column>
      <SectionTitleForm />
      <SectionTitleList />
    </Column>
  );
};

export default ManageSectionTitle;
